<div class="container">
  <mat-spinner></mat-spinner>
  <span class="authenticating-text">Logging in</span>
</div>
